; (function (jQuery) {

	"use strict";

	function Sliders() {

		var fn = {

			init: function ()
			{
				jQuery('.member-stories-slider').each(fn.sliderMembersStories);
				jQuery('.latest-news-slider').each(fn.sliderLatestNews);
				jQuery('.header-slider-large').each(fn.sliderHeaderLarge);
				jQuery.fn.matchHeight._maintainScroll = true; // Stops jumping with equal height slides
			},

			sliderMembersStories: function(i, el)
			{
				var slider = jQuery(el).find('.slider');
				var prev = jQuery(el).find('.member-stories-slider__arrows > .arrow--prev');
				var next = jQuery(el).find('.member-stories-slider__arrows > .arrow--next');
				var dotsColour = slider.data('dot-colour');
				slider.slick({
					lazyLoad: 'progressive',
					infinite: true,
					rows: 0,
					slidesToShow: 2,
  				slidesToScroll: 1,
					prevArrow: prev,
					nextArrow: next,
					dots: true,
					dotsClass: 'slick-dots slick-dots--dot-colour-' + dotsColour,
					mobileFirst: true,
					responsive:
					[{
						breakpoint: 770,
						settings: {
							slidesToShow: 1
						}
					}]
				});
			},

			sliderLatestNews: function(i, el)
			{
				var slider = jQuery(el).find('.slider');
				var dotsColour = slider.data('dot-colour');
				slider.slick({
					lazyLoad: 'progressive',
					infinite: true,
					rows: 0,
					slidesToShow: 2,
  				slidesToScroll: 1,
					arrows: false,
					dots: true,
					dotsClass: 'slick-dots slick-dots--dot-colour-' + dotsColour,
					mobileFirst: true,
					responsive:
					[{
						breakpoint: 800,
						settings: {
							slidesToShow: 3
						}
					}]
				});
			},

			sliderHeaderLarge: function(i, el)
			{
				var slider = jQuery(el).find('.slider');
				slider.slick({
					lazyLoad: 'progressive',
					infinite: false,
					rows: 0,
					slidesToShow: 1,
  				slidesToScroll: 1,
					arrows: false,
					dots: true,
					dotsClass: 'row slick-dots slick-dots--dot-colour-white',
					mobileFirst: true,
					focusOnSelect: true
				});
				// Same height slides
				slider.on('setPosition', function() {
					slider.find('.slick-slide').matchHeight();
				})
			},

			sliderDotsColour: function(slider)
			{
				if (["white", "gold"].includes(slider.data('bg-colour')))
				{
					return "purple";
				}
				else
				{
					return "white";
				}
			}

		}

		jQuery(fn.init);

	}

	new Sliders();

})(jQuery);